import { render, staticRenderFns } from "./UserTransactionApproveForm.vue?vue&type=template&id=739ae7f2"
import script from "./UserTransactionApproveForm.vue?vue&type=script&lang=js"
export * from "./UserTransactionApproveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports